import { useState } from "react"
import { observer } from "mobx-react"
import { Button, Flex, Table } from "antd"
import { ColumnsType } from "antd/es/table"
import { DeleteOutlined } from "@ant-design/icons"

import { DeleteConfirm } from "@src/app/components/DeleteConfirm"
import { notify } from "@src/app/components/notify"
import {
  WhiteListIp,
  WhiteLIstIpsCollection,
} from "@src/pages/settingsWhiteListIp/classes/WhiteLIstIpsCollection"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { dateTimeFormat } from "@src/shared/date"

type Props = WithCollection<WhiteLIstIpsCollection> & {
  deleteFn: (id: string) => Promise<boolean>
}
export const WhiteListIPTable = observer(({ collection, deleteFn }: Props) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)

  const [toDelete, setToDelete] = useState("")

  const showDeleteConfirm = (id: string) => {
    setToDelete(id)

    setOpenDeleteConfirm(true)
  }

  const onDeleteConfirm = () => {
    deleteFn(toDelete).then(() => {
      notify.success("Address has been deleted")

      setOpenDeleteConfirm(false)
    })
  }

  const columns: ColumnsType<WhiteListIp> = [
    {
      dataIndex: "address",
      title: "IP address",
      width: "40%",
    },
    {
      dataIndex: "description",
      title: "Description",
    },
    {
      dataIndex: "created_at",
      render: (_, { created_at }) => dateTimeFormat(created_at as string),
      title: "Created at",
    },
    {
      render: (_, { id }) => (
        <Flex gap={10}>
          <Button
            icon={<DeleteOutlined />}
            loading={collection.isLoading}
            onClick={() => showDeleteConfirm(id!)}
            type="text"
          />
        </Flex>
      ),
      title: "Action",
    },
  ]

  return (
    <>
      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        pagination={collection.pagination}
      />
      <DeleteConfirm
        cancelText="Cancel"
        isLoading={collection.isLoading}
        okText="Delete Address"
        onCancel={() => setOpenDeleteConfirm(false)}
        onOk={onDeleteConfirm}
        open={openDeleteConfirm}
        text="This action cannot be undone"
        title="Are you sure you want to delete this address?"
      />
    </>
  )
})
